module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/tools/modals/confirm-modal/confirm-modal.component.scss
// module id = ./src/app/components/tools/modals/confirm-modal/confirm-modal.component.scss
// module chunks = main